import { render } from "./EmployeeJob.vue?vue&type=template&id=f1481ba0&scoped=true"
import script from "./EmployeeJob.vue?vue&type=script&lang=js"
export * from "./EmployeeJob.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=f1481ba0&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1481ba0"]])

export default __exports__